import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'OrderSearchPage';

/**
 * Errors related to the Order Details page
 */
export const Errors = createErrors<Page, Component>('OrderSearch')({
    OrderSearchPage: {
        ValidateOrderFailed: {
            severity: 'MEDIUM',
            message: 'Failed to validate order search form',
        },
    },
});
